import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import * as fromCompanionRule from './reducers/companion-rule.reducer';
import {EffectsModule} from '@ngrx/effects';
import {CompanionRuleEffects} from './effects/companion-rule.effects';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature('companionRuleList', fromCompanionRule.reducer),
    EffectsModule.forFeature([ CompanionRuleEffects ]),
  ]
})
export class CompanionRuleModule { }
